import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class app_custom_ds_lp_count_by_project_warehouseService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { project_id: number, warehouse_id: number }): 
  Promise<{ result: { LicensePlatesCount?: number, Lot?: { Material?: { Project?: { Id?: number, Name?: string } } }, LicensePlate?: { Warehouse?: { Id?: number, Name?: string } } }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.project_id)) {
      $missingRequiredInParams.push('\'project_id\'');
    }
    if (isNil($inParams.warehouse_id)) {
      $missingRequiredInParams.push('\'warehouse_id\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getList($inParams: { project_id: number, warehouse_id: number, $top?: number, $skip?: number }): 
  Promise<{ result: { LicensePlatesCount?: number, Lot?: { Material?: { Project?: { Id?: number, Name?: string } } }, LicensePlate?: { Warehouse?: { Id?: number, Name?: string } } }[], totalCount: number }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.project_id)) {
      $missingRequiredInParams.push('\'project_id\'');
    }
    if (isNil($inParams.warehouse_id)) {
      $missingRequiredInParams.push('\'warehouse_id\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { project_id: number, warehouse_id: number, $keys: { Lot?: { Material?: { Project?: { Id?: number, Name?: string } } }, LicensePlate?: { Warehouse?: { Id?: number, Name?: string } } }[] }): 
  Promise<{ result: { LicensePlatesCount?: number, Lot?: { Material?: { Project?: { Id?: number, Name?: string } } }, LicensePlate?: { Warehouse?: { Id?: number, Name?: string } } }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.project_id)) {
      $missingRequiredInParams.push('\'project_id\'');
    }
    if (isNil($inParams.warehouse_id)) {
      $missingRequiredInParams.push('\'warehouse_id\'');
    }
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      project_id: number, warehouse_id: number    }) {
        if(isNil($inParams.project_id)) {
          return true; 
        }
        if(isNil($inParams.warehouse_id)) {
          return true; 
        }
      return false;
    }
}
